import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isEmpty } from '../typeguards/is-empty';

@Pipe({ name: 'isEmpty' })
export class IsEmptyPipe implements PipeTransform {
  transform<T>(value: T): value is T & (null | undefined | '' | unknown[]) {
    return isEmpty(value);
  }
}
